'use client';

import { PropsWithChildren, useLayoutEffect } from 'react';
import { usePermissions, useUserContext } from '@instamenu/context-user';
import { useRouter, usePathname } from 'next/navigation';
import { Loading } from '@instamenu/ui-system-next';

export const PrivateRoute = ({ children }: PropsWithChildren) => {
  const router = useRouter();
  const { isAuthenticated, isAuthorized, setRequestedPath, ready } = useUserContext();
  const pathname = usePathname();
  const { canAccessPath } = usePermissions();

  useLayoutEffect(() => {
    if (!ready) return;

    if (!isAuthenticated) {
      setRequestedPath(pathname);
      router.push('/sign-in');
      return;
    }

    if (!isAuthorized) {
      router.push('/unauthorized');
      return;
    }

    if (!canAccessPath(pathname)) {
      router.push('/unauthorized');
      return;
    }
  }, [ready, isAuthenticated, isAuthorized, pathname, router, setRequestedPath, canAccessPath]);

  if (!ready) {
    return <Loading logo containerStyle={{ minHeight: '100vh' }} />;
  }

  if (isAuthenticated && isAuthorized && canAccessPath(pathname)) {
    return children;
  }

  return <Loading logo containerStyle={{ minHeight: '100vh' }} />;
};
